export const capitalize = (str) => {
  const lower = str.toLowerCase();
  return str.charAt(0).toUpperCase() + lower.slice(1);
};

export const formatFileName = (name) => {
  return name.toLowerCase().replaceAll(' ', '_');
};

/**
 * @typedef {Object} Person
 * @property {string|null} [name] - The person's first name
 * @property {string|null} [lastName] - The person's last name
 * @property {string|null} [motherLastName] - The person's mother's last name
 */

/**
 * Gets the full name of a person by combining name, lastName, and motherLastName
 * @param {Person} [person] - The person object
 * @returns {string} The formatted full name or "-" if no person provided
 */
export const getFullName = (person) => {
  if (!person) return "-";

  const firstName = person.name ? person.name : "-";
  const lastName = person.lastName ?? "";
  const motherLastName = person.motherLastName ?? "";

  // trim() evita espacios dobles cuando falta algún apellido
  return `${firstName} ${lastName} ${motherLastName}`.trim();
};
